export const HOME = {
  productLink: "home-product-link",
};

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitButton: "login-submit-button",
  rememberCheckbox: "login-remember-checkbox",
  logoutButton: "topbar-logout-button",
  changePasswordButton: "topbar-change-password-button",
};

export const LAYOUT = {
  sidebar: "app-sidebar",
  topbar: "app-topbar",
  themeToggle: "topbar-theme-toggle",
  userMenu: "topbar-user-menu",
};

export const DASHBOARD = {
  root: "dashboard-root",
  kpiCard: (name) => `dashboard-kpi-${name}`,
};
